import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${Colors.Neutral100};
  ${Typography.Body}
  ${FontWeights.Regular}
  gap: ${Spacing.S};
  background-color: ${Colors.Blue10};
  padding: ${Spacing.S};
  border-radius: ${Spacing.S};

  ${Media.Phone`
    flex-direction: column;
  `}
`

export const ImgTextContainer = styled.div`
  display: flex;
  gap: ${Spacing.S};
  flex: 1;
  align-items: center;
`

export const Img = styled.img`
  width: 40px;
  height: 40px;
`

export const WrapperButton = styled.div`
  ${Media.Phone`
  width: 100%;
   & > * {
    width: 100%;
   }
 `}
`
